import { HAPPY_RETURNS_PROVIDER } from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { DropoffLabelButtons } from "./dropoff-label-buttons";
import {
  HappyReturnsConfirmationCard,
  type HappyReturnsConfirmationCardProps,
} from "./happy-returns-confirmation-card";

interface DropoffConfirmationProps extends HappyReturnsConfirmationCardProps {
  autoOpen?: boolean;
}

export function DropoffConfirmation({
  autoOpen,
  customerCountry,
  dropoffs,
  modalSubtitle,
  modalTitle,
  onOpenUrl,
  returnId,
  searchDropoffLocations,
}: DropoffConfirmationProps) {
  const isHappyReturns = dropoffs.qrCodes
    .map((qrCode) => qrCode.provider)
    .includes(HAPPY_RETURNS_PROVIDER);

  if (isHappyReturns) {
    return (
      <HappyReturnsConfirmationCard
        autoOpen={autoOpen}
        customerCountry={customerCountry}
        dropoffs={dropoffs}
        modalSubtitle={modalSubtitle}
        modalTitle={modalTitle}
        onOpenUrl={onOpenUrl}
        returnId={returnId}
        searchDropoffLocations={searchDropoffLocations}
      />
    );
  }

  return (
    <DropoffLabelButtons
      autoOpen={autoOpen}
      customerCountry={customerCountry}
      dropoffs={dropoffs}
      modalSubtitle={modalSubtitle}
      modalTitle={modalTitle}
      onOpenUrl={onOpenUrl}
      returnId={returnId}
      searchDropoffLocations={searchDropoffLocations}
    />
  );
}
